//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    assessmentApplicationGet(id: string): Promise<AssessmentApplication> {
        let url_ = this.baseUrl + "/api/AssessmentApplications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentApplicationGet(_response);
        });
    }

    protected processAssessmentApplicationGet(response: Response): Promise<AssessmentApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentApplication>(null as any);
    }

    /**
     * @return OK
     */
    getPrice(): Promise<number> {
        let url_ = this.baseUrl + "/api/AssessmentApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPrice(_response);
        });
    }

    protected processGetPrice(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    assessmentApplicationSubmit(body: AssessmentApplication | undefined): Promise<AssessmentApplicationResult> {
        let url_ = this.baseUrl + "/api/AssessmentApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentApplicationSubmit(_response);
        });
    }

    protected processAssessmentApplicationSubmit(response: Response): Promise<AssessmentApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessmentApplicationResult>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param sortingDesc (optional) 
     * @param search (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    assessmentsGet(sorting: AssessmentSorting | undefined, sortingDesc: boolean | undefined, search: string | undefined, pageNumber: number | undefined, pageSize: number | undefined): Promise<Assessment[]> {
        let url_ = this.baseUrl + "/api/Assessments?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sortingDesc === null)
            throw new Error("The parameter 'sortingDesc' cannot be null.");
        else if (sortingDesc !== undefined)
            url_ += "sortingDesc=" + encodeURIComponent("" + sortingDesc) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentsGet(_response);
        });
    }

    protected processAssessmentsGet(response: Response): Promise<Assessment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Assessment.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Assessment[]>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    assessmentsSave(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Assessments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentsSave(_response);
        });
    }

    protected processAssessmentsSave(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    assessmentsGetDetails(id: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Assessments/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessmentsGetDetails(_response);
        });
    }

    protected processAssessmentsGetDetails(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    assessorApplicationGetCurrent(): Promise<AssessorApplication> {
        let url_ = this.baseUrl + "/api/AssessorApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationGetCurrent(_response);
        });
    }

    protected processAssessorApplicationGetCurrent(response: Response): Promise<AssessorApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessorApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplication>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    assessorApplicationSave(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<AssessorApplication> {
        let url_ = this.baseUrl + "/api/AssessorApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationSave(_response);
        });
    }

    protected processAssessorApplicationSave(response: Response): Promise<AssessorApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessorApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplication>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    assessorApplicationSubmit(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<AssessorApplication> {
        let url_ = this.baseUrl + "/api/AssessorApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationSubmit(_response);
        });
    }

    protected processAssessorApplicationSubmit(response: Response): Promise<AssessorApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessorApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplication>(null as any);
    }

    /**
     * @return OK
     */
    assessorApplicationGetById(id: string): Promise<AssessorApplication> {
        let url_ = this.baseUrl + "/api/AssessorApplications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationGetById(_response);
        });
    }

    protected processAssessorApplicationGetById(response: Response): Promise<AssessorApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessorApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplication>(null as any);
    }

    /**
     * @return OK
     */
    assessorApplicationGetSaved(): Promise<AssessorApplicationItem[]> {
        let url_ = this.baseUrl + "/api/AssessorApplications/saved";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationGetSaved(_response);
        });
    }

    protected processAssessorApplicationGetSaved(response: Response): Promise<AssessorApplicationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessorApplicationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplicationItem[]>(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    assessorApplicationGetHistory(search: string | undefined): Promise<AssessorApplicationItem[]> {
        let url_ = this.baseUrl + "/api/AssessorApplications/history?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorApplicationGetHistory(_response);
        });
    }

    protected processAssessorApplicationGetHistory(response: Response): Promise<AssessorApplicationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessorApplicationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssessorApplicationItem[]>(null as any);
    }

    /**
     * @return OK
     */
    printByIdAssessorApplications(format: DocumentFormats, id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/AssessorApplications/print/{format}/{id}";
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintByIdAssessorApplications(_response);
        });
    }

    protected processPrintByIdAssessorApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    printFromModelAssessorApplications(format: DocumentFormats, body: AssessorApplication | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AssessorApplications/print/{format}";
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintFromModelAssessorApplications(_response);
        });
    }

    protected processPrintFromModelAssessorApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param state (optional) 
     * @param suburb (optional) 
     * @param pageNumber (optional) 
     * @return OK
     */
    assessorRegistryGet(state: string | undefined, suburb: string | undefined, pageNumber: number | undefined): Promise<RegistryAssessor[]> {
        let url_ = this.baseUrl + "/api/AssessorRegistry?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (suburb === null)
            throw new Error("The parameter 'suburb' cannot be null.");
        else if (suburb !== undefined)
            url_ += "suburb=" + encodeURIComponent("" + suburb) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorRegistryGet(_response);
        });
    }

    protected processAssessorRegistryGet(response: Response): Promise<RegistryAssessor[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistryAssessor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistryAssessor[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    assessorGetById(id: string | undefined): Promise<RegistryAssessor> {
        let url_ = this.baseUrl + "/api/AssessorRegistry/AssessorGetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorGetById(_response);
        });
    }

    protected processAssessorGetById(response: Response): Promise<RegistryAssessor> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistryAssessor.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistryAssessor>(null as any);
    }

    /**
     * @return OK
     */
    assessorRegistryGetStates(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AssessorRegistry/states";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorRegistryGetStates(_response);
        });
    }

    protected processAssessorRegistryGetStates(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param state (optional) 
     * @return OK
     */
    assessorRegistryGetSuburbs(state: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AssessorRegistry/suburbs?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssessorRegistryGetSuburbs(_response);
        });
    }

    protected processAssessorRegistryGetSuburbs(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    authorisationRequest(email: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Authorisation/request/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorisationRequest(_response);
        });
    }

    protected processAuthorisationRequest(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @param otp (optional) 
     * @return OK
     */
    authorisationConfirm(id: string | undefined, otp: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Authorisation/confirm?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (otp === null)
            throw new Error("The parameter 'otp' cannot be null.");
        else if (otp !== undefined)
            url_ += "otp=" + encodeURIComponent("" + otp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthorisationConfirm(_response);
        });
    }

    protected processAuthorisationConfirm(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return OK
     */
    callsignApplicationGetById(id: string): Promise<CallsignApplication> {
        let url_ = this.baseUrl + "/api/CallsignApplications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationGetById(_response);
        });
    }

    protected processCallsignApplicationGetById(response: Response): Promise<CallsignApplication> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignApplication.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignApplication>(null as any);
    }

    /**
     * @return OK
     */
    callsignApplicationGetSaved(): Promise<CallsignApplicationItem[]> {
        let url_ = this.baseUrl + "/api/CallsignApplications/saved";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationGetSaved(_response);
        });
    }

    protected processCallsignApplicationGetSaved(response: Response): Promise<CallsignApplicationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallsignApplicationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignApplicationItem[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    validateClientidentifier(id: string | undefined): Promise<IsClientIdentifierValidResult> {
        let url_ = this.baseUrl + "/api/CallsignApplications/validateclientidentifier?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateClientidentifier(_response);
        });
    }

    protected processValidateClientidentifier(response: Response): Promise<IsClientIdentifierValidResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsClientIdentifierValidResult>(null as any);
    }

    /**
     * @param search (optional) 
     * @return OK
     */
    callsignApplicationGetHistory(search: string | undefined): Promise<CallsignApplicationItem[]> {
        let url_ = this.baseUrl + "/api/CallsignApplications/history?";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationGetHistory(_response);
        });
    }

    protected processCallsignApplicationGetHistory(response: Response): Promise<CallsignApplicationItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallsignApplicationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignApplicationItem[]>(null as any);
    }

    /**
     * @return OK
     */
    getReassignChargingRules(): Promise<ReassignChargingRule[]> {
        let url_ = this.baseUrl + "/api/CallsignApplications/reapply";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReassignChargingRules(_response);
        });
    }

    protected processGetReassignChargingRules(response: Response): Promise<ReassignChargingRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReassignChargingRule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReassignChargingRule[]>(null as any);
    }

    /**
     * @return OK
     */
    getChargingRules(): Promise<ChargingRule[]> {
        let url_ = this.baseUrl + "/api/CallsignApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetChargingRules(_response);
        });
    }

    protected processGetChargingRules(response: Response): Promise<ChargingRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChargingRule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChargingRule[]>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    callsignApplicationSave(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<CallsignApplicationResult> {
        let url_ = this.baseUrl + "/api/CallsignApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationSave(_response);
        });
    }

    protected processCallsignApplicationSave(response: Response): Promise<CallsignApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignApplicationResult>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    callsignApplicationSubmit(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<CallsignApplicationResult> {
        let url_ = this.baseUrl + "/api/CallsignApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationSubmit(_response);
        });
    }

    protected processCallsignApplicationSubmit(response: Response): Promise<CallsignApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignApplicationResult>(null as any);
    }

    /**
     * @param type (optional) 
     * @param includeReserved (optional) 
     * @param search (optional) 
     * @return OK
     */
    callsignApplicationGetAvailable(type: Acma_amateurradiocallsigntypes | undefined, includeReserved: boolean | undefined, search: string | undefined): Promise<AvailableCallsign[]> {
        let url_ = this.baseUrl + "/api/CallsignApplications/callsigns?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (includeReserved === null)
            throw new Error("The parameter 'includeReserved' cannot be null.");
        else if (includeReserved !== undefined)
            url_ += "includeReserved=" + encodeURIComponent("" + includeReserved) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationGetAvailable(_response);
        });
    }

    protected processCallsignApplicationGetAvailable(response: Response): Promise<AvailableCallsign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableCallsign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableCallsign[]>(null as any);
    }

    /**
     * @param data (optional) 
     * @param fileNames (optional) 
     * @param files (optional) 
     * @return OK
     */
    callsignApplicationReconfirmation(data: string | undefined, fileNames: string | undefined, files: FileParameter[] | undefined): Promise<CallSignReconfirmationRequestResult> {
        let url_ = this.baseUrl + "/api/CallsignApplications/reconfirmation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (data === null || data === undefined)
            throw new Error("The parameter 'data' cannot be null.");
        else
            content_.append("Data", data.toString());
        if (fileNames === null || fileNames === undefined)
            throw new Error("The parameter 'fileNames' cannot be null.");
        else
            content_.append("FileNames", fileNames.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignApplicationReconfirmation(_response);
        });
    }

    protected processCallsignApplicationReconfirmation(response: Response): Promise<CallSignReconfirmationRequestResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallSignReconfirmationRequestResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallSignReconfirmationRequestResult>(null as any);
    }

    /**
     * @return OK
     */
    printByIdCallsignApplications(format: DocumentFormats, id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/CallsignApplications/print/{format}/{id}";
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintByIdCallsignApplications(_response);
        });
    }

    protected processPrintByIdCallsignApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    printFromModelCallsignApplications(format: DocumentFormats, body: CallsignApplication | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CallsignApplications/print/{format}";
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrintFromModelCallsignApplications(_response);
        });
    }

    protected processPrintFromModelCallsignApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param availability (optional) 
     * @param prefix (optional) 
     * @param location (optional) 
     * @param type (optional) 
     * @param search (optional) 
     * @param pageNumber (optional) 
     * @return OK
     */
    callsignRegistryGet(availability: Acma_amateurradiocallsignavailability | undefined, prefix: Acma_amateurradiocallsignprefixes | undefined, location: Acma_amateurradiolocations | undefined, type: Acma_amateurradiocallsigntypes | undefined, search: string | undefined, pageNumber: number | undefined): Promise<RegistryCallsign[]> {
        let url_ = this.baseUrl + "/api/CallsignRegistry?";
        if (availability === null)
            throw new Error("The parameter 'availability' cannot be null.");
        else if (availability !== undefined)
            url_ += "availability=" + encodeURIComponent("" + availability) + "&";
        if (prefix === null)
            throw new Error("The parameter 'prefix' cannot be null.");
        else if (prefix !== undefined)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        if (location === null)
            throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignRegistryGet(_response);
        });
    }

    protected processCallsignRegistryGet(response: Response): Promise<RegistryCallsign[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistryCallsign.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistryCallsign[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    callsignTransferPUT(body: CallsignTransfer | undefined): Promise<CallsignTransferApplicationResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignTransferPUT(_response);
        });
    }

    protected processCallsignTransferPUT(response: Response): Promise<CallsignTransferApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignTransferApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignTransferApplicationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    callsignTransferPOST(body: CallsignTransfer | undefined): Promise<CallsignTransferApplicationResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignTransferPOST(_response);
        });
    }

    protected processCallsignTransferPOST(response: Response): Promise<CallsignTransferApplicationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignTransferApplicationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignTransferApplicationResult>(null as any);
    }

    /**
     * @return OK
     */
    callsignTransferGET(): Promise<number> {
        let url_ = this.baseUrl + "/api/CallsignTransfer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallsignTransferGET(_response);
        });
    }

    protected processCallsignTransferGET(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param callsignname (optional) 
     * @param email (optional) 
     * @return OK
     */
    validateTransferEmailAddress(callsignname: string | undefined, email: string | undefined): Promise<IsEmailAddressValidResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer/validatetransferemailaddress?";
        if (callsignname === null)
            throw new Error("The parameter 'callsignname' cannot be null.");
        else if (callsignname !== undefined)
            url_ += "callsignname=" + encodeURIComponent("" + callsignname) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateTransferEmailAddress(_response);
        });
    }

    protected processValidateTransferEmailAddress(response: Response): Promise<IsEmailAddressValidResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsEmailAddressValidResult>(null as any);
    }

    /**
     * @param callsignname (optional) 
     * @param id (optional) 
     * @return OK
     */
    validateTransferClientidentifier(callsignname: string | undefined, id: string | undefined): Promise<IsClientIdentifierValidResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer/validatetransferclientidentifier?";
        if (callsignname === null)
            throw new Error("The parameter 'callsignname' cannot be null.");
        else if (callsignname !== undefined)
            url_ += "callsignname=" + encodeURIComponent("" + callsignname) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateTransferClientidentifier(_response);
        });
    }

    protected processValidateTransferClientidentifier(response: Response): Promise<IsClientIdentifierValidResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IsClientIdentifierValidResult>(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    transfer(invitationId: string | undefined): Promise<CallsignTransferInvitationResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer/transfer?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTransfer(_response);
        });
    }

    protected processTransfer(response: Response): Promise<CallsignTransferInvitationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignTransferInvitationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignTransferInvitationResult>(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    accept(invitationId: string | undefined): Promise<CallsignTransferInvitationResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer/accept?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccept(_response);
        });
    }

    protected processAccept(response: Response): Promise<CallsignTransferInvitationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignTransferInvitationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignTransferInvitationResult>(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    reject(invitationId: string | undefined): Promise<CallsignTransferInvitationResult> {
        let url_ = this.baseUrl + "/api/CallsignTransfer/reject?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: Response): Promise<CallsignTransferInvitationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallsignTransferInvitationResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallsignTransferInvitationResult>(null as any);
    }

    /**
     * @param invitationId (optional) 
     * @return OK
     */
    operatorGet(invitationId: string | undefined): Promise<OperatorPayload> {
        let url_ = this.baseUrl + "/api/Operator?";
        if (invitationId === null)
            throw new Error("The parameter 'invitationId' cannot be null.");
        else if (invitationId !== undefined)
            url_ += "invitationId=" + encodeURIComponent("" + invitationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorGet(_response);
        });
    }

    protected processOperatorGet(response: Response): Promise<OperatorPayload> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OperatorPayload.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperatorPayload>(null as any);
    }

    /**
     * @return OK
     */
    operatorCheck(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Operator/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorCheck(_response);
        });
    }

    protected processOperatorCheck(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    operatorUpdateContactDetails(body: OperatorContactDetails | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Operator/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorUpdateContactDetails(_response);
        });
    }

    protected processOperatorUpdateContactDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    operatorReconfirmCallsign(name: string | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/Operator/callsign?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorReconfirmCallsign(_response);
        });
    }

    protected processOperatorReconfirmCallsign(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(null as any);
    }

    /**
     * @param name (optional) 
     * @return OK
     */
    operatorSurrenderCallsign(name: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Operator/callsign?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorSurrenderCallsign(_response);
        });
    }

    protected processOperatorSurrenderCallsign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    operatorDownloadDocumentation(fileName: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Operator/documentation/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorDownloadDocumentation(_response);
        });
    }

    protected processOperatorDownloadDocumentation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    operatorDownloadCertificate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Operator/certificate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOperatorDownloadCertificate(_response);
        });
    }

    protected processOperatorDownloadCertificate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Address implements IAddress {
    addressLine1?: string | undefined;
    suburb?: string | undefined;
    state?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressLine1 = _data["addressLine1"];
            this.suburb = _data["suburb"];
            this.state = _data["state"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressLine1"] = this.addressLine1;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        return data;
    }
}

export interface IAddress {
    addressLine1?: string | undefined;
    suburb?: string | undefined;
    state?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
}

export class Assessment implements IAssessment {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    dob?: Date | undefined;
    emailAddress?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    method?: Acma_amateurradioassessmentmethods;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    approvedOn?: Date | undefined;
    theoreticalComponent?: Acma_amateurradioexamstatuses;
    theoreticalScore?: number | undefined;
    regulatoryComponent?: Acma_amateurradioexamstatuses;
    regulatoryScore?: number | undefined;
    practicalComponent?: Acma_amateurradioexamstatuses;
    practicalResult?: Acma_amateurradioexamresults;
    existingQualification?: boolean | undefined;
    existingQualificationComments?: string | undefined;
    specialExamination?: boolean | undefined;
    specialExaminationComments?: string | undefined;
    fileNames?: string[] | undefined;

    constructor(data?: IAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.type = _data["type"];
            this.method = _data["method"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.theoreticalComponent = _data["theoreticalComponent"];
            this.theoreticalScore = _data["theoreticalScore"];
            this.regulatoryComponent = _data["regulatoryComponent"];
            this.regulatoryScore = _data["regulatoryScore"];
            this.practicalComponent = _data["practicalComponent"];
            this.practicalResult = _data["practicalResult"];
            this.existingQualification = _data["existingQualification"];
            this.existingQualificationComments = _data["existingQualificationComments"];
            this.specialExamination = _data["specialExamination"];
            this.specialExaminationComments = _data["specialExaminationComments"];
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): Assessment {
        data = typeof data === 'object' ? data : {};
        let result = new Assessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["type"] = this.type;
        data["method"] = this.method;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["theoreticalComponent"] = this.theoreticalComponent;
        data["theoreticalScore"] = this.theoreticalScore;
        data["regulatoryComponent"] = this.regulatoryComponent;
        data["regulatoryScore"] = this.regulatoryScore;
        data["practicalComponent"] = this.practicalComponent;
        data["practicalResult"] = this.practicalResult;
        data["existingQualification"] = this.existingQualification;
        data["existingQualificationComments"] = this.existingQualificationComments;
        data["specialExamination"] = this.specialExamination;
        data["specialExaminationComments"] = this.specialExaminationComments;
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        return data;
    }
}

export interface IAssessment {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    dob?: Date | undefined;
    emailAddress?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    method?: Acma_amateurradioassessmentmethods;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    approvedOn?: Date | undefined;
    theoreticalComponent?: Acma_amateurradioexamstatuses;
    theoreticalScore?: number | undefined;
    regulatoryComponent?: Acma_amateurradioexamstatuses;
    regulatoryScore?: number | undefined;
    practicalComponent?: Acma_amateurradioexamstatuses;
    practicalResult?: Acma_amateurradioexamresults;
    existingQualification?: boolean | undefined;
    existingQualificationComments?: string | undefined;
    specialExamination?: boolean | undefined;
    specialExaminationComments?: string | undefined;
    fileNames?: string[] | undefined;
}

export class AssessmentApplication implements IAssessmentApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    method?: Acma_amateurradioassessmentmethods;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    approvedOn?: Date | undefined;
    title?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    assessorName?: string | undefined;
    tokenisedCard?: string | undefined;
    dob?: Date | undefined;

    constructor(data?: IAssessmentApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.emailAddress = _data["emailAddress"];
            this.type = _data["type"];
            this.method = _data["method"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.address1 = _data["address1"] ? Address.fromJS(_data["address1"]) : <any>undefined;
            this.assessorName = _data["assessorName"];
            this.tokenisedCard = _data["tokenisedCard"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssessmentApplication {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["emailAddress"] = this.emailAddress;
        data["type"] = this.type;
        data["method"] = this.method;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["address1"] = this.address1 ? this.address1.toJSON() : <any>undefined;
        data["assessorName"] = this.assessorName;
        data["tokenisedCard"] = this.tokenisedCard;
        data["dob"] = this.dob ? this.dob.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAssessmentApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    method?: Acma_amateurradioassessmentmethods;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    approvedOn?: Date | undefined;
    title?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    assessorName?: string | undefined;
    tokenisedCard?: string | undefined;
    dob?: Date | undefined;
}

export class AssessmentApplicationResult implements IAssessmentApplicationResult {
    application?: AssessmentApplication;
    error?: string | undefined;

    constructor(data?: IAssessmentApplicationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? AssessmentApplication.fromJS(_data["application"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): AssessmentApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentApplicationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface IAssessmentApplicationResult {
    application?: AssessmentApplication;
    error?: string | undefined;
}

export enum AssessmentSorting {
    Acma_Name = "acma_Name",
    EmailAddress = "EmailAddress",
    Acma_Type = "acma_Type",
    Acma_Score = "acma_Score",
    CreatedOn = "CreatedOn",
}

export class AssessorApplication implements IAssessorApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    type?: Acma_amateurradioassessortypes;
    callsign?: string | undefined;
    pastRejection?: boolean | undefined;
    advertised?: boolean | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;
    status?: Acma_amateurradioassessor_statuscode;
    fileNames?: string[] | undefined;

    constructor(data?: IAssessorApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.emailAddress = _data["emailAddress"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.address1 = _data["address1"] ? Address.fromJS(_data["address1"]) : <any>undefined;
            this.type = _data["type"];
            this.callsign = _data["callsign"];
            this.pastRejection = _data["pastRejection"];
            this.advertised = _data["advertised"];
            this.advertisedAddress = _data["advertisedAddress"] ? Address.fromJS(_data["advertisedAddress"]) : <any>undefined;
            this.advertisedEmail = _data["advertisedEmail"];
            this.advertisedPhone = _data["advertisedPhone"];
            this.status = _data["status"];
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): AssessorApplication {
        data = typeof data === 'object' ? data : {};
        let result = new AssessorApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["emailAddress"] = this.emailAddress;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["address1"] = this.address1 ? this.address1.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["callsign"] = this.callsign;
        data["pastRejection"] = this.pastRejection;
        data["advertised"] = this.advertised;
        data["advertisedAddress"] = this.advertisedAddress ? this.advertisedAddress.toJSON() : <any>undefined;
        data["advertisedEmail"] = this.advertisedEmail;
        data["advertisedPhone"] = this.advertisedPhone;
        data["status"] = this.status;
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        return data;
    }
}

export interface IAssessorApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    type?: Acma_amateurradioassessortypes;
    callsign?: string | undefined;
    pastRejection?: boolean | undefined;
    advertised?: boolean | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;
    status?: Acma_amateurradioassessor_statuscode;
    fileNames?: string[] | undefined;
}

export class AssessorApplicationItem implements IAssessorApplicationItem {
    id?: string;
    referenceNumber?: string | undefined;
    modifiedOn?: Date | undefined;
    status?: Acma_amateurradioassessor_statuscode;

    constructor(data?: IAssessorApplicationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssessorApplicationItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssessorApplicationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IAssessorApplicationItem {
    id?: string;
    referenceNumber?: string | undefined;
    modifiedOn?: Date | undefined;
    status?: Acma_amateurradioassessor_statuscode;
}

export class AvailableCallsign implements IAvailableCallsign {
    name?: string | undefined;
    reservedTo?: string | undefined;

    constructor(data?: IAvailableCallsign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.reservedTo = _data["reservedTo"];
        }
    }

    static fromJS(data: any): AvailableCallsign {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableCallsign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["reservedTo"] = this.reservedTo;
        return data;
    }
}

export interface IAvailableCallsign {
    name?: string | undefined;
    reservedTo?: string | undefined;
}

export class CallSignReconfirmationRequest implements ICallSignReconfirmationRequest {
    id?: string;
    referenceNumber?: string | undefined;
    callSignId?: string | undefined;
    status?: Acma_amateurradiocallsignreconfirmation_statuscode;
    additionalInformation?: string | undefined;
    location?: Acma_amateurradiolocations;
    clubName?: string | undefined;
    tokenisedCard?: string | undefined;
    fileNames?: string[] | undefined;
    dates?: string | undefined;

    constructor(data?: ICallSignReconfirmationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.callSignId = _data["callSignId"];
            this.status = _data["status"];
            this.additionalInformation = _data["additionalInformation"];
            this.location = _data["location"];
            this.clubName = _data["clubName"];
            this.tokenisedCard = _data["tokenisedCard"];
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
            this.dates = _data["dates"];
        }
    }

    static fromJS(data: any): CallSignReconfirmationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CallSignReconfirmationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["callSignId"] = this.callSignId;
        data["status"] = this.status;
        data["additionalInformation"] = this.additionalInformation;
        data["location"] = this.location;
        data["clubName"] = this.clubName;
        data["tokenisedCard"] = this.tokenisedCard;
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        data["dates"] = this.dates;
        return data;
    }
}

export interface ICallSignReconfirmationRequest {
    id?: string;
    referenceNumber?: string | undefined;
    callSignId?: string | undefined;
    status?: Acma_amateurradiocallsignreconfirmation_statuscode;
    additionalInformation?: string | undefined;
    location?: Acma_amateurradiolocations;
    clubName?: string | undefined;
    tokenisedCard?: string | undefined;
    fileNames?: string[] | undefined;
    dates?: string | undefined;
}

export class CallSignReconfirmationRequestResult implements ICallSignReconfirmationRequestResult {
    request?: CallSignReconfirmationRequest;
    error?: string | undefined;

    constructor(data?: ICallSignReconfirmationRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.request = _data["request"] ? CallSignReconfirmationRequest.fromJS(_data["request"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CallSignReconfirmationRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallSignReconfirmationRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface ICallSignReconfirmationRequestResult {
    request?: CallSignReconfirmationRequest;
    error?: string | undefined;
}

export class CallsignApplication implements ICallsignApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    clientIdentificationNumber?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    letters?: string | undefined;
    dates?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    specialEventDetails?: string | undefined;
    outsideOfState?: boolean | undefined;
    outsideOfStateReason?: string | undefined;
    clubRepresentative?: boolean | undefined;
    clubName?: string | undefined;
    assessmentReferenceNumber?: string | undefined;
    tokenisedCard?: string | undefined;
    fileNames?: string[] | undefined;

    constructor(data?: ICallsignApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.clientIdentificationNumber = _data["clientIdentificationNumber"];
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.emailAddress = _data["emailAddress"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.address1 = _data["address1"] ? Address.fromJS(_data["address1"]) : <any>undefined;
            this.prefix = _data["prefix"];
            this.location = _data["location"];
            this.type = _data["type"];
            this.letters = _data["letters"];
            this.dates = _data["dates"];
            this.status = _data["status"];
            this.specialEventDetails = _data["specialEventDetails"];
            this.outsideOfState = _data["outsideOfState"];
            this.outsideOfStateReason = _data["outsideOfStateReason"];
            this.clubRepresentative = _data["clubRepresentative"];
            this.clubName = _data["clubName"];
            this.assessmentReferenceNumber = _data["assessmentReferenceNumber"];
            this.tokenisedCard = _data["tokenisedCard"];
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CallsignApplication {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["clientIdentificationNumber"] = this.clientIdentificationNumber;
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["emailAddress"] = this.emailAddress;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["address1"] = this.address1 ? this.address1.toJSON() : <any>undefined;
        data["prefix"] = this.prefix;
        data["location"] = this.location;
        data["type"] = this.type;
        data["letters"] = this.letters;
        data["dates"] = this.dates;
        data["status"] = this.status;
        data["specialEventDetails"] = this.specialEventDetails;
        data["outsideOfState"] = this.outsideOfState;
        data["outsideOfStateReason"] = this.outsideOfStateReason;
        data["clubRepresentative"] = this.clubRepresentative;
        data["clubName"] = this.clubName;
        data["assessmentReferenceNumber"] = this.assessmentReferenceNumber;
        data["tokenisedCard"] = this.tokenisedCard;
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        return data;
    }
}

export interface ICallsignApplication {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    clientIdentificationNumber?: string | undefined;
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    letters?: string | undefined;
    dates?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    specialEventDetails?: string | undefined;
    outsideOfState?: boolean | undefined;
    outsideOfStateReason?: string | undefined;
    clubRepresentative?: boolean | undefined;
    clubName?: string | undefined;
    assessmentReferenceNumber?: string | undefined;
    tokenisedCard?: string | undefined;
    fileNames?: string[] | undefined;
}

export class CallsignApplicationItem implements ICallsignApplicationItem {
    id?: string;
    referenceNumber?: string | undefined;
    modifiedOn?: Date | undefined;
    status?: Acma_amateurradiocallsign_statuscode;

    constructor(data?: ICallsignApplicationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CallsignApplicationItem {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignApplicationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICallsignApplicationItem {
    id?: string;
    referenceNumber?: string | undefined;
    modifiedOn?: Date | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
}

export class CallsignApplicationResult implements ICallsignApplicationResult {
    application?: CallsignApplication;
    error?: string | undefined;

    constructor(data?: ICallsignApplicationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? CallsignApplication.fromJS(_data["application"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CallsignApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignApplicationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface ICallsignApplicationResult {
    application?: CallsignApplication;
    error?: string | undefined;
}

export class CallsignTransfer implements ICallsignTransfer {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    callSignId?: string | undefined;
    callSignName?: string | undefined;
    clientIdentificationNumber?: string | undefined;
    title?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    clubRepresentative?: boolean | undefined;
    clubName?: string | undefined;
    qualificationLevel?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    tokenisedCard?: string | undefined;

    constructor(data?: ICallsignTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.callSignId = _data["callSignId"];
            this.callSignName = _data["callSignName"];
            this.clientIdentificationNumber = _data["clientIdentificationNumber"];
            this.title = _data["title"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.address1 = _data["address1"] ? Address.fromJS(_data["address1"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.emailAddress = _data["emailAddress"];
            this.clubRepresentative = _data["clubRepresentative"];
            this.clubName = _data["clubName"];
            this.qualificationLevel = _data["qualificationLevel"];
            this.status = _data["status"];
            this.tokenisedCard = _data["tokenisedCard"];
        }
    }

    static fromJS(data: any): CallsignTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["callSignId"] = this.callSignId;
        data["callSignName"] = this.callSignName;
        data["clientIdentificationNumber"] = this.clientIdentificationNumber;
        data["title"] = this.title;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["address1"] = this.address1 ? this.address1.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["emailAddress"] = this.emailAddress;
        data["clubRepresentative"] = this.clubRepresentative;
        data["clubName"] = this.clubName;
        data["qualificationLevel"] = this.qualificationLevel;
        data["status"] = this.status;
        data["tokenisedCard"] = this.tokenisedCard;
        return data;
    }
}

export interface ICallsignTransfer {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    callSignId?: string | undefined;
    callSignName?: string | undefined;
    clientIdentificationNumber?: string | undefined;
    title?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    clubRepresentative?: boolean | undefined;
    clubName?: string | undefined;
    qualificationLevel?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    tokenisedCard?: string | undefined;
}

export class CallsignTransferApplicationResult implements ICallsignTransferApplicationResult {
    application?: CallsignTransfer;
    error?: string | undefined;

    constructor(data?: ICallsignTransferApplicationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? CallsignTransfer.fromJS(_data["application"]) : <any>undefined;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CallsignTransferApplicationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignTransferApplicationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["error"] = this.error;
        return data;
    }
}

export interface ICallsignTransferApplicationResult {
    application?: CallsignTransfer;
    error?: string | undefined;
}

export class CallsignTransferInvitationResult implements ICallsignTransferInvitationResult {
    error?: string | undefined;

    constructor(data?: ICallsignTransferInvitationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CallsignTransferInvitationResult {
        data = typeof data === 'object' ? data : {};
        let result = new CallsignTransferInvitationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        return data;
    }
}

export interface ICallsignTransferInvitationResult {
    error?: string | undefined;
}

export class ChargingRule implements IChargingRule {
    prefixes?: Acma_amateurradiocallsignprefixes[] | undefined;
    locations?: Acma_amateurradiolocations[] | undefined;
    types?: Acma_amateurradiocallsigntypes[] | undefined;
    pickedNextAvailable?: boolean | undefined;
    price?: number;

    constructor(data?: IChargingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["prefixes"])) {
                this.prefixes = [] as any;
                for (let item of _data["prefixes"])
                    this.prefixes!.push(item);
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.pickedNextAvailable = _data["pickedNextAvailable"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ChargingRule {
        data = typeof data === 'object' ? data : {};
        let result = new ChargingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.prefixes)) {
            data["prefixes"] = [];
            for (let item of this.prefixes)
                data["prefixes"].push(item);
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["pickedNextAvailable"] = this.pickedNextAvailable;
        data["price"] = this.price;
        return data;
    }
}

export interface IChargingRule {
    prefixes?: Acma_amateurradiocallsignprefixes[] | undefined;
    locations?: Acma_amateurradiolocations[] | undefined;
    types?: Acma_amateurradiocallsigntypes[] | undefined;
    pickedNextAvailable?: boolean | undefined;
    price?: number;
}

export enum DocumentFormats {
    Pdf = "Pdf",
    Word = "Word",
}

export class Documentation implements IDocumentation {
    fileName?: string | undefined;
    title?: string | undefined;

    constructor(data?: IDocumentation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): Documentation {
        data = typeof data === 'object' ? data : {};
        let result = new Documentation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["title"] = this.title;
        return data;
    }
}

export interface IDocumentation {
    fileName?: string | undefined;
    title?: string | undefined;
}

export enum IsClientIdentifierValidResult {
    Valid = "Valid",
    InvalidClient = "InvalidClient",
    PreferredContactNotEmail = "PreferredContactNotEmail",
    FoundNoContactForAccount = "FoundNoContactForAccount",
    FoundMultipleContactsForAccount = "FoundMultipleContactsForAccount",
    NoEmailRecorded = "NoEmailRecorded",
    InvalidTransferToSelf = "InvalidTransferToSelf",
}

export enum IsEmailAddressValidResult {
    Valid = "Valid",
    Invalid = "Invalid",
    InvalidTransferToSelf = "InvalidTransferToSelf",
}

export class OperatorAssessment implements IOperatorAssessment {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    assessmentMethod?: Acma_amateurradioassessmentmethods;

    constructor(data?: IOperatorAssessment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referenceNumber = _data["referenceNumber"];
            this.type = _data["type"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assessmentMethod = _data["assessmentMethod"];
        }
    }

    static fromJS(data: any): OperatorAssessment {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorAssessment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referenceNumber"] = this.referenceNumber;
        data["type"] = this.type;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assessmentMethod"] = this.assessmentMethod;
        return data;
    }
}

export interface IOperatorAssessment {
    id?: string | undefined;
    referenceNumber?: string | undefined;
    type?: Acma_amateurradioassessmenttypes;
    createdOn?: Date | undefined;
    status?: Acma_amateurradioassessment_statuscode;
    assessmentMethod?: Acma_amateurradioassessmentmethods;
}

export class OperatorCallsign implements IOperatorCallsign {
    callsignId?: string;
    name?: string | undefined;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    approvedOn?: Date | undefined;
    expireOrReconfirmBy?: Date | undefined;
    reapplyFrom?: Date | undefined;
    letters?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    existsPendingReconfirmationRequest?: boolean;
    readonly nextReconfirmDate?: Date | undefined;
    clubName?: string | undefined;

    constructor(data?: IOperatorCallsign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callsignId = _data["callsignId"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.location = _data["location"];
            this.type = _data["type"];
            this.approvedOn = _data["approvedOn"] ? new Date(_data["approvedOn"].toString()) : <any>undefined;
            this.expireOrReconfirmBy = _data["expireOrReconfirmBy"] ? new Date(_data["expireOrReconfirmBy"].toString()) : <any>undefined;
            this.reapplyFrom = _data["reapplyFrom"] ? new Date(_data["reapplyFrom"].toString()) : <any>undefined;
            this.letters = _data["letters"];
            this.status = _data["status"];
            this.existsPendingReconfirmationRequest = _data["existsPendingReconfirmationRequest"];
            (<any>this).nextReconfirmDate = _data["nextReconfirmDate"] ? new Date(_data["nextReconfirmDate"].toString()) : <any>undefined;
            this.clubName = _data["clubName"];
        }
    }

    static fromJS(data: any): OperatorCallsign {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorCallsign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callsignId"] = this.callsignId;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["location"] = this.location;
        data["type"] = this.type;
        data["approvedOn"] = this.approvedOn ? this.approvedOn.toISOString() : <any>undefined;
        data["expireOrReconfirmBy"] = this.expireOrReconfirmBy ? this.expireOrReconfirmBy.toISOString() : <any>undefined;
        data["reapplyFrom"] = this.reapplyFrom ? this.reapplyFrom.toISOString() : <any>undefined;
        data["letters"] = this.letters;
        data["status"] = this.status;
        data["existsPendingReconfirmationRequest"] = this.existsPendingReconfirmationRequest;
        data["nextReconfirmDate"] = this.nextReconfirmDate ? this.nextReconfirmDate.toISOString() : <any>undefined;
        data["clubName"] = this.clubName;
        return data;
    }
}

export interface IOperatorCallsign {
    callsignId?: string;
    name?: string | undefined;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    approvedOn?: Date | undefined;
    expireOrReconfirmBy?: Date | undefined;
    reapplyFrom?: Date | undefined;
    letters?: string | undefined;
    status?: Acma_amateurradiocallsign_statuscode;
    existsPendingReconfirmationRequest?: boolean;
    nextReconfirmDate?: Date | undefined;
    clubName?: string | undefined;
}

export class OperatorContact implements IOperatorContact {
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;

    constructor(data?: IOperatorContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.otherName = _data["otherName"];
            this.emailAddress = _data["emailAddress"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.address1 = _data["address1"] ? Address.fromJS(_data["address1"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OperatorContact {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["otherName"] = this.otherName;
        data["emailAddress"] = this.emailAddress;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["address1"] = this.address1 ? this.address1.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOperatorContact {
    title?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    otherName?: string | undefined;
    emailAddress?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    address1?: Address;
}

export class OperatorContactDetails implements IOperatorContactDetails {
    contact?: OperatorContact;
    registryContact?: OperatorRegistryContact;

    constructor(data?: IOperatorContactDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? OperatorContact.fromJS(_data["contact"]) : <any>undefined;
            this.registryContact = _data["registryContact"] ? OperatorRegistryContact.fromJS(_data["registryContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OperatorContactDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorContactDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["registryContact"] = this.registryContact ? this.registryContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOperatorContactDetails {
    contact?: OperatorContact;
    registryContact?: OperatorRegistryContact;
}

export class OperatorPayload implements IOperatorPayload {
    contact?: OperatorContact;
    registryContact?: OperatorRegistryContact;
    isAssessor?: boolean;
    assessments?: OperatorAssessment[] | undefined;
    callsigns?: OperatorCallsign[] | undefined;
    documenation?: Documentation[] | undefined;

    constructor(data?: IOperatorPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? OperatorContact.fromJS(_data["contact"]) : <any>undefined;
            this.registryContact = _data["registryContact"] ? OperatorRegistryContact.fromJS(_data["registryContact"]) : <any>undefined;
            this.isAssessor = _data["isAssessor"];
            if (Array.isArray(_data["assessments"])) {
                this.assessments = [] as any;
                for (let item of _data["assessments"])
                    this.assessments!.push(OperatorAssessment.fromJS(item));
            }
            if (Array.isArray(_data["callsigns"])) {
                this.callsigns = [] as any;
                for (let item of _data["callsigns"])
                    this.callsigns!.push(OperatorCallsign.fromJS(item));
            }
            if (Array.isArray(_data["documenation"])) {
                this.documenation = [] as any;
                for (let item of _data["documenation"])
                    this.documenation!.push(Documentation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OperatorPayload {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["registryContact"] = this.registryContact ? this.registryContact.toJSON() : <any>undefined;
        data["isAssessor"] = this.isAssessor;
        if (Array.isArray(this.assessments)) {
            data["assessments"] = [];
            for (let item of this.assessments)
                data["assessments"].push(item.toJSON());
        }
        if (Array.isArray(this.callsigns)) {
            data["callsigns"] = [];
            for (let item of this.callsigns)
                data["callsigns"].push(item.toJSON());
        }
        if (Array.isArray(this.documenation)) {
            data["documenation"] = [];
            for (let item of this.documenation)
                data["documenation"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOperatorPayload {
    contact?: OperatorContact;
    registryContact?: OperatorRegistryContact;
    isAssessor?: boolean;
    assessments?: OperatorAssessment[] | undefined;
    callsigns?: OperatorCallsign[] | undefined;
    documenation?: Documentation[] | undefined;
}

export class OperatorRegistryContact implements IOperatorRegistryContact {
    advertised?: boolean | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;

    constructor(data?: IOperatorRegistryContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advertised = _data["advertised"];
            this.advertisedAddress = _data["advertisedAddress"] ? Address.fromJS(_data["advertisedAddress"]) : <any>undefined;
            this.advertisedEmail = _data["advertisedEmail"];
            this.advertisedPhone = _data["advertisedPhone"];
        }
    }

    static fromJS(data: any): OperatorRegistryContact {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorRegistryContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advertised"] = this.advertised;
        data["advertisedAddress"] = this.advertisedAddress ? this.advertisedAddress.toJSON() : <any>undefined;
        data["advertisedEmail"] = this.advertisedEmail;
        data["advertisedPhone"] = this.advertisedPhone;
        return data;
    }
}

export interface IOperatorRegistryContact {
    advertised?: boolean | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;
}

export class ReassignChargingRule implements IReassignChargingRule {
    specialEventType?: SpecialEventType;
    price?: number;

    constructor(data?: IReassignChargingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialEventType = _data["specialEventType"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ReassignChargingRule {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignChargingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialEventType"] = this.specialEventType;
        data["price"] = this.price;
        return data;
    }
}

export interface IReassignChargingRule {
    specialEventType?: SpecialEventType;
    price?: number;
}

export class RegistryAssessor implements IRegistryAssessor {
    fullName?: string | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;
    type?: Acma_amateurradioassessortypes;

    constructor(data?: IRegistryAssessor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.advertisedAddress = _data["advertisedAddress"] ? Address.fromJS(_data["advertisedAddress"]) : <any>undefined;
            this.advertisedEmail = _data["advertisedEmail"];
            this.advertisedPhone = _data["advertisedPhone"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RegistryAssessor {
        data = typeof data === 'object' ? data : {};
        let result = new RegistryAssessor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["advertisedAddress"] = this.advertisedAddress ? this.advertisedAddress.toJSON() : <any>undefined;
        data["advertisedEmail"] = this.advertisedEmail;
        data["advertisedPhone"] = this.advertisedPhone;
        data["type"] = this.type;
        return data;
    }
}

export interface IRegistryAssessor {
    fullName?: string | undefined;
    advertisedAddress?: Address;
    advertisedEmail?: string | undefined;
    advertisedPhone?: string | undefined;
    type?: Acma_amateurradioassessortypes;
}

export class RegistryCallsign implements IRegistryCallsign {
    callsignName?: string | undefined;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    letters?: string | undefined;
    availability?: Acma_amateurradiocallsignavailability;
    reservedTo?: string | undefined;
    reservationType?: Acma_amateurradioreservationtypes;

    constructor(data?: IRegistryCallsign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callsignName = _data["callsignName"];
            this.prefix = _data["prefix"];
            this.location = _data["location"];
            this.type = _data["type"];
            this.letters = _data["letters"];
            this.availability = _data["availability"];
            this.reservedTo = _data["reservedTo"];
            this.reservationType = _data["reservationType"];
        }
    }

    static fromJS(data: any): RegistryCallsign {
        data = typeof data === 'object' ? data : {};
        let result = new RegistryCallsign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callsignName"] = this.callsignName;
        data["prefix"] = this.prefix;
        data["location"] = this.location;
        data["type"] = this.type;
        data["letters"] = this.letters;
        data["availability"] = this.availability;
        data["reservedTo"] = this.reservedTo;
        data["reservationType"] = this.reservationType;
        return data;
    }
}

export interface IRegistryCallsign {
    callsignName?: string | undefined;
    prefix?: Acma_amateurradiocallsignprefixes;
    location?: Acma_amateurradiolocations;
    type?: Acma_amateurradiocallsigntypes;
    letters?: string | undefined;
    availability?: Acma_amateurradiocallsignavailability;
    reservedTo?: string | undefined;
    reservationType?: Acma_amateurradioreservationtypes;
}

export enum SpecialEventType {
    None = "None",
    VK09Callsign = "VK09Callsign",
    SpecialCallsign = "SpecialCallsign",
    ContestCallsign = "ContestCallsign",
}

export enum Acma_amateurradioassessment_statuscode {
    Reported = "Reported",
    Declined = "Declined",
    Approved = "Approved",
    Requested = "Requested",
    Issued = "Issued",
}

export enum Acma_amateurradioassessmentmethods {
    PriorLearningRecognition = "PriorLearningRecognition",
    FaceToFace = "FaceToFace",
    VideoConference = "VideoConference",
    Telephone = "Telephone",
    DataMigration = "DataMigration",
    PreviousQualification = "PreviousQualification",
}

export enum Acma_amateurradioassessmenttypes {
    Foundation = "Foundation",
    Standard = "Standard",
    Advanced = "Advanced",
}

export enum Acma_amateurradioassessor_statuscode {
    Draft = "Draft",
    Declined = "Declined",
    Submitted = "Submitted",
    Approved = "Approved",
}

export enum Acma_amateurradioassessortypes {
    Standard = "Standard",
    Specialist = "Specialist",
}

export enum Acma_amateurradiocallsign_statuscode {
    Draft = "Draft",
    Declined = "Declined",
    Submitted = "Submitted",
    Approved = "Approved",
    Surrendered = "Surrendered",
    Transferred = "Transferred",
    Expired = "Expired",
    Transferring = "Transferring",
}

export enum Acma_amateurradiocallsignavailability {
    Assigned = "Assigned",
    Available = "Available",
    Reserved = "Reserved",
    Pending = "Pending",
}

export enum Acma_amateurradiocallsignprefixes {
    VK = "VK",
    VJ = "VJ",
    VL = "VL",
    SpecialEvent = "SpecialEvent",
}

export enum Acma_amateurradiocallsignreconfirmation_statuscode {
    Draft = "Draft",
    Declined = "Declined",
    Submitted = "Submitted",
    Approved = "Approved",
}

export enum Acma_amateurradiocallsigntypes {
    TwoByOneContest = "TwoByOneContest",
    TwoLetter = "TwoLetter",
    ThreeLetter = "ThreeLetter",
    FSeries = "FSeries",
}

export enum Acma_amateurradioexamresults {
    NotCompetent = "NotCompetent",
    Competent = "Competent",
}

export enum Acma_amateurradioexamstatuses {
    ExaminationTakenUnderMySupervision = "ExaminationTakenUnderMySupervision",
    ExaminationPassedInThePast = "ExaminationPassedInThePast",
    ExaminationIsScheduledForFutureDate = "ExaminationIsScheduledForFutureDate",
    PassedUnderPriorLearningRecognition = "PassedUnderPriorLearningRecognition",
}

export enum Acma_amateurradiolocations {
    Antarctic = "Antarctic",
    ACT = "ACT",
    NSW = "NSW",
    VIC = "VIC",
    QLD = "QLD",
    SA = "SA",
    WA = "WA",
    TAS = "TAS",
    NT = "NT",
    AustralianExternalTerritories = "AustralianExternalTerritories",
}

export enum Acma_amateurradioreservationtypes {
    Blocked = "Blocked",
    Reserved = "Reserved",
    SpecialEvent = "SpecialEvent",
    Deceased = "Deceased",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}